module.exports = __webpack_public_path__ + "img/yajirushi_scroll.f2e60683.png";